var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup75(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6571 26.1174C48.6526 20.113 40.5089 16.7397 32.0174 16.7397C23.5258 16.7397 15.3821 20.113 9.37767 26.1174C3.37325 32.1218 -2.69916e-07 40.2656 0 48.7571C2.69916e-07 57.2486 3.37325 65.3924 9.37767 71.3968L32.0174 48.7571L54.6571 26.1174Z",
    fill: "url(#paint0_linear_179_186)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2724 55.076C32.3229 61.0341 40.4923 64.3446 48.9836 64.2792C57.4749 64.2139 65.5924 60.7781 71.5505 54.7277C77.5085 48.6773 80.819 40.5078 80.7537 32.0166C80.6884 23.5253 77.2526 15.4077 71.2022 9.44968L48.7373 32.2628L26.2724 55.076Z",
    fill: "#3646DA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_179_186",
    x1: 15.5365,
    y1: 37.362,
    x2: 51.5466,
    y2: 77.3203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC8DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F7714E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup75);
export default __webpack_public_path__ + "static/media/Group 75.d1fe2fc605e3bcf9ddc42aea2cb6beef.svg";
export { ForwardRef as ReactComponent };